import {
  Module, VuexModule, Mutation, Action
} from 'vuex-module-decorators';
import api from '@/api/group_xiaoyu';

@Module({ namespaced: true })
export default class extends VuexModule {
  @Action
  async list(params: any) {
    return api.getList(params);
  }

  @Action
  async detail(params: any) {
    return api.detail(params);
  }

  @Action
  async total(params: any) {
    return api.getTotal(params);
  }
}
